import Vue from 'vue';
import router from '../../../ugsrc/router/index';
import { EventBus } from '../../../common/assets/utils/eventBus';

export const loginDetails = {
    namespaced: true,
    state: {
        loggedInUserInformation: null,
        server: null
    },
    actions: {
      initializeData({state, commit, dispatch}, data) {
        let formData = new FormData();
        formData.append('json', JSON.stringify({
          'switched_schema_name' : data.schemaName || null,
          'session': data.accessToken || null
        }));
        EventBus.$emit('showLoadingIcon', true);
        Vue.http.post('/getuserinfo/', formData)
        .then((res) => {
          try{
            let userData = res.data;
            
            commit('saveInitializeUserData', userData);
            dispatch('appsDetails/resetAllAppsData', [], { root: true });
            dispatch('usersDetails/resetAllUsersData', [], { root: true});
            
            if(data.route){
              router.push(`/${data.route}`);
            }else {
              let appsInformation = userData['apps_information'];
              let docsInformation = userData['docs_information'];
              console.log("%%")
              console.log(userData);
              console.log("^^^")
              // console.log(appsInformation);
              let publicUser = userData['tenant_information']['schema_name'] == 'public' && userData['is_superuser'] ? true : false;
              console.log(userData['is_superuser']);
              console.log(userData['tenant_information']['schema_name']);
              console.log(publicUser);
              if(publicUser === false && userData['is_superadmin'] === false && userData['is_tenantadmin'] === false && Object.keys(appsInformation).length == 0 && Object.keys(docsInformation).length == 0){
                console.log("In login.module.js -- if condition")
                router.push('/noapp_nodoc');
              }
              // else if(Object.keys(appsInformation).length == 0 && Object.keys(docsInformation).length){
              //   router.push('/docs/all');
              // }
            }

            // TIP - SM for walkme in future
            window.fouriq_tenant = userData['tenant_information']['name'];
          }
          catch(err){
            console.log("error is:",err);
          }
          finally{
            EventBus.$emit('showLoadingIcon', false);
          }            
        }, (error) => {
            EventBus.$emit('showLoadingIcon', false);
            console.log('API failed', err);
        });
      },
      userPageInfo({commit, dispatch}) {
        let self = this;
        EventBus.$emit('showLoadingIcon', true);
        Vue.http.get('/me')
        .then((res) => {
          let userData = res.data;
          try{
            if(userData.has_no_apps_docs){
              if (userData.role === 'tenantAdmin') {
                router.push('/apps');
                // Change Here.
              } else {
                console.log('loginmodeule - else');
                router.push('/noapp_nodoc');
              }
            }else if(window.location.search.substr(6) && window.location.search.startsWith('?next=')){
                window.location = window.location.search.substr(6);
            }else if(userData.app_details['app_name'] && userData.app_details['app_name'] != 'app') {
              if(userData.app_details['app_name'] == 'doc'){
                router.push('/docs/all');
              }else if(userData.app_details['app_name'] && !userData.accept_tnc){
                window.location = "/apps/"+userData.app_details['app_name']+"/index/?at="+userData.session;
              }else {
                console.log("*************");
                router.push('/apps');
              }
            }
            else{
              console.log("^^^^^^^^^^^^");
              router.push('/apps');
              // router.push('/dashboard');
            }
          }
          catch(err){
            console.log("error is:",err);
          }
          finally{
            EventBus.$emit('showLoadingIcon', false);
          }            
        }, (error) => {
            EventBus.$emit('showLoadingIcon', false);
            console.log('API failed', err);
        });
      },
      getCurrentHostName({state, commit, dispatch}, data) {
        EventBus.$emit('showLoadingIcon', true);
        Vue.http.get('/get_host_name/').then(
          (res) => {
            try {
              // #TODO we are Not using this api now - remove it later
              let data = res.data.data || '';
              let server = null;
              if (window.location.href.includes("dome")) {
                  server = 'dome'
              } else {
                  server = 'uig'
              }
              commit('saveHostName', server);
            } catch(err) {
              console.log("error is:",err);
            } finally {
              EventBus.$emit('showLoadingIcon', false);
            }   
          }, (error) => {
              EventBus.$emit('showLoadingIcon', false);
              console.log(error, "Unable to fetch host name");
          }
      );
      }
    },
    mutations: {
      saveInitializeUserData(state, userData){
        state.loggedInUserInformation = userData;
      },
      saveHostName(state, server) {
        state.server = server;
      }
    },
  };
  